var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isSmaller)?_c('div',{staticClass:"page-title mt-0 mb-8"},[_c('h2',[_vm._v("訂單確認")])]):_vm._e(),_c('div',{staticClass:"well-received"},[_vm._v("感謝您的訂購！")]),_c('p',{staticClass:"days mt-16"},[_vm._v("商品將於 5 個工作日內寄出")]),_c('p',{staticClass:"nice-day mt-8 mb-16"},[_vm._v("Have a nice day!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }